<script setup lang="ts">

import { DataProviderInterface, dpi } from '@piveau/piveau-hub-ui-modules';
import { getValidationMessages } from '@formkit/validation'
import { createMessage, getNode} from '@formkit/core'
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
const dcatapdeOdb = JSON.parse(JSON.stringify(dpi.dpiSpecConfig?.dcatapdeODB))
dcatapdeOdb.inputDefinition.distributions.accessService.$formkit = 'repeatableDataService'
const context = {
  specification: dcatapdeOdb,
  specificationName: 'dcatapde-odb-patched',
}

dcatapdeOdb.inputDefinition.datasets.keyword.children[0].children[0].identifier = 'language'
dcatapdeOdb.inputDefinition.distributions.licence = {
  $formkit: 'auto',
  name: 'dct:license',
  identifier: 'licence',
  voc: 'licence',
  class: 'property inDistribution',
}
dcatapdeOdb.inputDefinition.datasets.politicalGeocodingURI = {
  identifier: 'politicalGeocodingURI',
  $formkit: 'repeatable',
  name: 'dcatde:politicalGeocodingURI',
  vocabularyOnly: true,
  props: {
    vocabularyOnly: true,
  },
  children: [
    {
      $formkit: 'spatialinput',
      name: 'dcatde:politicalGeocodingURI',
      identifier: 'politicalGeocodingURI',
      vocabularyOnly: true,
    }]
},
dcatapdeOdb.inputDefinition.datasets.admsIdentifier.children[0].children[0].validation = 'admsIdentifierUriRequiredIfSibling|url'
dcatapdeOdb.inputDefinition.datasets.admsIdentifier.children[0].children[0].validationMessages = {
  admsIdentifierUriRequiredIfSibling: 'Eine URL ist erforderlich'
}
dcatapdeOdb.inputDefinition.datasets.admsIdentifier.children[0].children[0].validationVisibility = 'live'
dcatapdeOdb.inputDefinition.datasets.admsIdentifier.children[0].validationVisibility = 'live'

dcatapdeOdb.inputDefinition.distributions.accessURL.children[0].validationType = 'required|url'
// ⚠️ WARNING: do not apply .validation here -> bug that causes validation errors to be counted twice
// Don't ask why
// dcatapdeOdb.inputDefinition.distributions.accessURL.children[0].validation = 'url'

// dcatapdeOdb.inputDefinition.datasets.admsIdentifier.children[0].validation = '+admsIdentifierUriRequiredIfSibling'

// remove dct:subject
dcatapdeOdb.pageConent.datasets.Advised = (dcatapdeOdb.pageConent.datasets.Advised as string[]).filter((prop: string) => prop !== 'subject')

// process through the nested dcatapdeOdb object recursively
// recursion occurs whenever the object contains children, which contains an array of objects
function processObject(obj: any) {
  for (const [key, value] of Object.entries(obj)) {
    // if object contains name === '@language' and '$formkit' === 'select', then set property value to 'de'
    if (key === 'name' && value === '@language' && obj.$formkit === 'select') {
      obj.value = 'de'
    }

    // translate date and datetime for modified and created
    // options: { date: 'Date', datetime: 'Datetime' },
    if (key === '$formkit' && value === 'select' && obj?.options?.date === 'Date' && obj?.options?.datetime === 'Datetime') {
      obj.options.date = 'Datum'
      obj.options.datetime = 'Datum & Uhrzeit'
    }

    if (typeof value === 'object') {
      processObject(value)
    }
  }
}


function triggerValidationFor(step: string) {
  const node = getNode(step)

  if (node === undefined)
    return

  // the node.walk() method walks through all the descendants of the current node
  // and executes the provided function.
  node.walk((n) => {
    n.store.set(
      createMessage({
        key: 'submitted',
        value: true,
        visible: false,
      }),
    )
  })
  node.store.set(
    createMessage({
      key: 'submitted',
      value: true,
      visible: false,
    }),
  )
}
processObject(dcatapdeOdb)

const route = useRoute()
const isEditMode = computed(() => !!route.query.edit && route.query.edit === 'true')

// hack: trigger validation for edit mode so that invalid inputs are highlighted
onMounted(async () => {
  if (!isEditMode.value) return
  let rootNode = getNode('dpiForm')
  if (rootNode) triggerValidationFor('dpiForm')

  // hack: after 5s, trigger validation every 5s, up to 10 times
  for (let i = 0; i < 10; i++) {
    await new Promise((resolve) => setTimeout(resolve, 5000))
    rootNode = getNode('dpiForm')
    if (!rootNode) break;
    triggerValidationFor('dpiForm')
  }
})
</script>

<template>
  <div>
    <DataProviderInterface id="bayern-data-provider-interface" :dpi-context="context" />
  </div>
</template>
